import React from 'react';
import './Checkbox.css';

const checkedImage = '/images/icons/checked.png';
const uncheckedImage = '/images/icons/unchecked.png';

const Checkbox = ({ checked, onChange, label, marginBottom, fontSize = '1.2em' }) => {
  const imageSource = checked ? checkedImage : uncheckedImage;

  const handleClick = () => {
    if (onChange) {
      onChange(!checked);
    }
  };

  const containerStyle = { marginBottom: marginBottom || 0 };
  const labelStyle = { fontSize };

  return (
    <div className="checkbox-container" style={containerStyle}>
      <button onClick={handleClick} className="checkbox-button">
        <img src={imageSource} alt="" className="checkbox-image" />
      </button>
      <div className="checkbox-label" style={labelStyle}>
        <span>{label}</span>
      </div>
    </div>
  );
};

export default Checkbox;
